import config from "utils/appConfig";

export const createPendoVisitor = (userInfo = {}) => {
	const { buildENV } = config;
	const {
		department = {},
		securityGroup = {},
		profileRole = {},
		location = {},
		id,
		email,
		name,
	} = userInfo;

	return {
		department_name: department?.name,
		department_id: department?.id,
		securityGroup_name: securityGroup?.description,
		securityGroup_id: securityGroup?.id,
		profileRole_name: profileRole?.name,
		profileRole_id: profileRole?.id,
		location_name: location?.name,
		location_id: location?.id,
		id,
		email,
		full_name: name,
		environment: buildENV,
		product: "Creative Manager",
		language: window.navigator.language,
	};
};

/**
 * [initPendo description]
 * 	This initalizes the Pendo Help system in the application
 * 		The Pendo script is loaded here (rather than in `index.html`) so that the
 * 		`pendoApiKey` can be read at run-time, which is a requirement of the ci/cd pipeline
 * 	This function takes the user object and sets some initial information on Pendo for tracking
 * 		For full documentation of Pendo object please see Pendo Docs
 *
 * 		To prevent application breaking things, we wrap both groups in a try/catch
 * 		This allows our Application to work regardless of the status of Pendo
 * 		*************************************************************
 * 		 We DO NOT WANT TO BREAK OUR APP if a 3rd party script fails
 *    	*************************************************************
 *
 * @param  {object} userInfo User object from crm/v1/user
 *                           Each application's `user/` endpoint returns slightly different data
 *                           The `visitor` object will need to be adjusted based on the data returned
 *                           	We should always have access to:
 *                           	id
 *                           	email
 *                           	full_name
 *
 * @return {undefined}          Nothing
 */
export function initPendo(userInfo = {}) {
	const { buildENV, pendoApiKey } = config;

	if (/dev/gi.test(buildENV)) {
		console.info("%cPendo%c is %cdisabled%c for local testing", "color: #40b658; font-weight:bold;", "color:#fff; font-weight:normal;", "color:red; font-weight:bold;", "color:#fff; font-weight:normal;");
		console.log();
		return;
	}

	if (!pendoApiKey) {
		console.info("No API Key, Pendo disabled");
		return;
	}

	try {
		// The code block below is the verbatim Pendo bootstrap snippet for loading pendo.js.
		// It is an exact copy/paste of the script tag code provided by Pendo, with the arg `pendoApiKey` being the only modification
		// This code is here instead of in the html so that pendoApiKey can be set at run-time, rather than build-time, which is a ci/cd requirement
		/* eslint-disable */
		(function(apiKey){
			(function(p,e,n,d,o){var v,w,x,y,z;o=p[d]=p[d]||{};o._q=o._q||[];
			v=['initialize','identify','updateOptions','pageLoad','track'];for(w=0,x=v.length;w<x;++w)(function(m){
			o[m]=o[m]||function(){o._q[m===v[0]?'unshift':'push']([m].concat([].slice.call(arguments,0)));};})(v[w]);
			y=e.createElement(n);y.async=!0;y.src='https://cdn.pendo.io/agent/static/'+apiKey+'/pendo.js';
			z=e.getElementsByTagName(n)[0];z.parentNode.insertBefore(y,z);})(window,document,'script','pendo');
		})(pendoApiKey);
		/* eslint-enable */
	} catch (err) {
		/* eslint-disable indent */
		console.groupCollapsed("Pendo Snippet Problem");
			console.error("Problem embedding the Pendo Snippet");
			console.error(err);
		console.groupEnd();
		/* eslint-enable indent */
		return;
	}



	try {
		const { businessEntity } = userInfo;
		const visitor = createPendoVisitor(userInfo);

		// eslint-disable-next-line no-undef
		pendo.initialize({
			account: businessEntity,
			visitor,
		});
	} catch (err) {
		/* eslint-disable indent */
		console.groupCollapsed("Pendo Init Problem");
		console.error("Problem Starting up Pendo");
		console.error(err);
		console.groupEnd();
		/* eslint-enable indent */
	}
}
